import { ReactElement, useContext, useEffect, useState } from 'react';

import cms from '../../../data/cms.json';

import { Step } from '../../Step/Step';
import { AppContext } from '../../../context/AppContext';

import axios from 'axios';
import { getBaseUrl } from '../../../utils/getBaseUrl';
import { Formik } from 'formik';
import { Box } from '../../Box/Box';
import { Button } from '../../Button/Button';
import { FormItemError } from '../../FormItemError/FormItemError';
import { TextField } from '../../TextField/TextField';
import { Label } from '../../Label/Label';

interface TestProps {
    className?: string;
}

export const Test = ({ className }: TestProps): ReactElement | null => {
    const [formError, setFormError] = useState(false);
    const ctx = useContext(AppContext);
    const [serverResponse, setServerResonse] = useState<string>();
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        ctx.setIsBackButtonVisible(true);
    }, []);

    if (formError) {
        return (
            <Step title={cms.steperror.title} text={null} className={className}>
                <Label>{serverResponse ?? ''}</Label>
            </Step>
        );
    }

    return (
        <Formik
            validateOnBlur={false}
            validateOnChange={submitted}
            validateOnMount={false}
            initialValues={{
                interval: '',
            }}
            onSubmit={(values) => {
                setSubmitted(true);
                setFormError(false);
                axios
                    .get(`${getBaseUrl()}api/online/misc/wait-for-local/${values.interval}`)
                    .then((response) => {
                        if (response) {
                            setServerResonse(response.data);
                        } else {
                            setFormError(true);
                        }
                    })
                    .catch((error) => {
                        setFormError(true);
                        setServerResonse(error);
                        console.error(error);
                    })
                    .finally(() => {
                        setSubmitted(false);
                    });
            }}
        >
            {({ errors, handleSubmit }) => (
                <Step title="Testovací stránka" text="">
                    <Box innerWrapper data-test="testingPageBox">
                        <>
                            <div className="mb-6">
                                <TextField
                                    name="interval"
                                    variant="number"
                                    label="Vyplňte číslo v sekunách, jak dlouho má trvat zpracovat požadavek na serveru"
                                    max={99999}
                                    error={errors.interval}
                                    data-test="interval"
                                />
                                {errors.interval && <FormItemError text={errors.interval} data-test="intervalError" />}
                            </div>

                            <Button
                                className="mb-6"
                                variant="primary"
                                loading={submitted}
                                onClick={() => {
                                    setSubmitted(true);
                                    handleSubmit();
                                }}
                                data-test="testButton"
                            >
                                Test odezvy
                            </Button>
                            <Label data-test="serverResponse">{serverResponse ?? ''}</Label>
                        </>
                    </Box>
                </Step>
            )}
        </Formik>
    );
};
